/**
 * Variables
 * ---------
 */

/* Set/get in more than one place */

const globals = {
  ioSupported: false,
  loaderDone: false,
  reduceMotion: false,
  keyCodes: {
    13: "ENTER",
    Enter: "ENTER",
    32: "SPACE",
    Space: "SPACE",
    27: "ESC",
    Escape: "ESC",
    9: "TAB",
    Tab: "TAB",
  },
};

/* Export */

export default globals;
